/* Dialog Text */
import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {
  InteractSubContents,
  InteractSubTypeLicenses,
  Interacts,
  Interact,
} from "../../../api/models";
import { AdminInteractiveSubService } from "../../../api/services";
import {
  TextEditDialogData,
  TextEditDialogComponent,
} from "../../text-edit-dialog/text-edit-dialog.component";

export interface EditXmlaSubscriptionsDialogData {
  dialogTitle: string;
  isNew: boolean;
  xmlaSubscriptionTypeId: number;
  xmlaSubscriptionTypeName: string;
  description: string;
  licenseHtml: string;
}

@Component({
  selector: "edit-xmla-subscription-dialog",
  styleUrls: ["edit-xmla-subscription-dialog.component.css"],
  templateUrl: "./edit-xmla-subscription-dialog.component.html",
})
export class EditXmlaSubscriptionsDialogComponent {
  public Result: DialogResult;
  public isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<EditXmlaSubscriptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditXmlaSubscriptionsDialogData,
    private dialog: MatDialog
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  editLicense() {
    var licenseText: string = "";

    if (this.data.licenseHtml != null && this.data.licenseHtml.length > 0) {
      licenseText = this.data.licenseHtml;
    }

    var params: TextEditDialogData = {
      title: "Add / Edit License",
      prompt: "Enter license HTML below",
      data: licenseText,
    };

    var dialogRef = this.dialog.open(TextEditDialogComponent, {
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        this.data.licenseHtml = result.ResultData;
      }
    });
  }
}
